import React from 'react';
import {clsx} from "clsx";
import {cn} from "../utils/style";

function Tabs({tabs, get, set}) {
	if (!tabs) return null;
	return (
		<div className="my-6">
			<div className="sm:block overflow-x-auto">
				<div className="p-1 inline-flex bg-gray-100/50 rounded-2xl backdrop-blur-sm border border-gray-100">
					<nav className="flex gap-x-1" aria-label="Tabs">
						{tabs.map((tab) => {
							const isActive = tab?.column === get;
							return (
								<button
									key={tab?.column}
									onClick={() => set(tab?.column)}
									className={cn(
										"group relative flex items-center whitespace-nowrap rounded-xl py-2 px-4 text-sm font-bold transition-all duration-200 select-none",
										isActive
											? "bg-white text-[#0b6a8c] shadow-sm"
											: "text-gray-500 hover:text-gray-700 hover:bg-white/50"
									)}
									aria-current={isActive ? 'page' : undefined}
								>
									<span>{tab?.name}</span>
									{tab?.count !== undefined && tab?.count !== null ? (
										<span
											className={cn(
												"shrink-0 ltr:ml-2 rtl:mr-2 rounded-full px-1.5 py-0.5 min-w-5 text-[10px] font-black transition-colors duration-200",
												isActive
													? "bg-[#0b6a8c] text-white" 
													: "bg-gray-200 text-gray-600 group-hover:bg-gray-300"
											)}
										>
											{tab?.count}
										</span>
									) : null}
								</button>
							);
						})}
					</nav>
				</div>
			</div>
		</div>
	);
}

export default Tabs;
